module.exports = __webpack_public_path__ + "static/media/ve.9f23d962.svg";